import styled from "styled-components";

export const Container = styled.div`
  display: flex;
  align-items: center;
`;

export const Label = styled.div`
  font-size: 1rem;
  line-height: 0.9rem;
  font-weight: 400;
  color: #4b5563;
  margin-right: 0.8rem;
`;

export const Logo = styled.svg`
  flex-shrink: 0;
`;
